module.exports = __webpack_public_path__ + "img/recharge.43b7a7ec.png";